import React from "react";
import LegalPage from "@/components/legal/LegalPage";
import { privacyChoicesContent } from "@/content/legal/privacy-choices";

export default function PrivacyChoices() {
  return (
    <LegalPage
      titleKey="public.privacyChoices.title"
      updatedKey="public.lastUpdated"
      metaDescriptionKey="public.privacyChoices.meta"
      sectionsByLang={privacyChoicesContent}
      testId="page-privacy-choices"
    />
  );
}
